import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModuleFE_Dialog, ModuleFE_Print, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import './Dialog_DiseaseProfileComparator.scss';
import { PgDev_DPReport } from './PgDev_DPReport/index.js';
import { ICONS } from '@app/styles';
export class Dialog_DiseaseProfileComparator extends TS_Dialog {
    // ######################## Static ########################
    static defaultProps = {
        dialogId: 'disease-profile-comparator',
    };
    static show(diseaseProfiles) {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_DiseaseProfileComparator, { diseaseProfiles: diseaseProfiles }), closeOverlayOnClick: () => false });
    }
    // ######################## Render ########################
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsx("span", { className: "header__title", children: "Disease Profile Comparator" }), _jsx("div", { className: 'header__buttons', children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: () => this.closeDialog() }) })] });
    };
    renderBody = () => {
        return _jsx(PgDev_DPReport.renderer, { diseaseProfiles: this.props.diseaseProfiles });
    };
    buttons = () => {
        return {
            right: [
                { content: 'Close', onClick: () => this.closeDialog() },
                {
                    content: 'Print',
                    onClick: () => {
                        const div = document.getElementById('dp-report');
                        ModuleFE_Print.printElement(div, [{ key: 'theme', value: 'light' }]);
                    }
                }
            ],
        };
    };
}
//# sourceMappingURL=Dialog_DiseaseProfileComparator.js.map